export const VANITY_URL_SAVE_SUC = 'vanityUrl.save.success';
export const vanityUrlSaveSuccess = (uuid, name) => ({
  type: VANITY_URL_SAVE_SUC,
  uuid,
  name,
});
